import {
  CONVERSATION_PERMISSIONS,
  ROLES,
} from 'dashboard/constants/permissions';
import { frontendURL } from '../../../helper/URLHelper';
import EmailTriageIndex from './EmailTriageIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/email-triage'),
    name: 'email_triage_index',
    component: EmailTriageIndex,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
];
